import React from "react";
import { MapPin, Mail, Clock } from "lucide-react";
import Layout, { Breadcrumbs } from "../components/Layout";
import Seo from "../components/Seo";

const crumbs = [
  { name: "Home", path: "/" },
  { name: "Reputed Counters", path: "/reputed-counters/" },
];

const EMAIL = "shillongteermorning4758@gmail.com";

export default function ReputedCounters() {
  return (
    <Layout>
      <Seo
        title="Bhutan Morning Teer Reputed Counters – Archery Ground Address"
        description="Bhutan Morning Teer reputed counters — address of the traditional archery ground in Bhutan and our official contact email."
        path="/reputed-counters/"
        breadcrumb={crumbs}
      />
      <Breadcrumbs items={crumbs} />

      <div className="mx-auto max-w-xl px-4 py-5">
        <h1 className="text-2xl font-extrabold text-[#10161f] sm:text-3xl">
          Reputed Counters
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          Bhutan Morning Teer is a traditional archery-based number game. Below
          is the address of the main archery ground in Bhutan where the game is
          played, along with our official contact.
        </p>

        {/* Address card */}
        <div
          data-testid="counter-address"
          className="mt-5 rounded-2xl border-2 border-[#1ab5a3] bg-white p-5 shadow-sm"
        >
          <div className="flex items-start gap-3">
            <MapPin className="mt-0.5 shrink-0 text-[#1ab5a3]" size={22} />
            <div>
              <h2 className="text-base font-bold text-[#10161f] sm:text-lg">
                Archery Ground Address
              </h2>
              <address className="mt-1 not-italic text-[15px] leading-relaxed text-slate-700">
                Changlimithang Archery Ground,
                <br />
                Chang Lam, Thimphu,
                <br />
                Thimphu Dzongkhag,
                <br />
                Kingdom of Bhutan
              </address>
            </div>
          </div>

          <div className="mt-4 flex items-start gap-3 border-t border-slate-100 pt-4">
            <Clock className="mt-0.5 shrink-0 text-[#1ab5a3]" size={20} />
            <div className="text-[15px] text-slate-700">
              <span className="font-semibold text-[#10161f]">Draw Timings:</span>{" "}
              F/R around 10:30 AM &amp; S/R around 11:30 AM (daily)
            </div>
          </div>
        </div>

        {/* Contact card */}
        <div
          data-testid="counter-contact"
          className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-5"
        >
          <div className="flex items-center gap-3">
            <Mail className="shrink-0 text-[#1ab5a3]" size={22} />
            <div className="min-w-0">
              <h2 className="text-base font-bold text-[#10161f]">Contact Email</h2>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="counter-email"
                className="break-all text-[15px] font-semibold text-[#0f9b8a] hover:underline"
              >
                {EMAIL}
              </a>
            </div>
          </div>
        </div>

        <p className="mt-5 text-xs text-slate-500">
          Note: This information is provided for reference only. For any query
          about Bhutan Morning Teer, please reach us at the email above.
        </p>
      </div>
    </Layout>
  );
}
